import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Authentification from './screens/Authentification';
import AffichageRapport from './screens/AffichageRapport';
import Navbar from './components/layout/Navbar';
import Validation from './screens/Validation';
import MenuRapport from './screens/MenuRapport';

import { aucunDroit, isAuthentified } from './store/actions/authActions';

import { auth, db } from './config/fbConfig';
import { signInAnonymously } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [droit, setDroit] = useState('');

  useEffect(() => {
    const initApp = async () => {
      try {
        await signInAnonymously(auth);
      } catch (error) {
        console.error(error);
      }

      if (!localStorage.UUID) {
        navigate('/authentification', { replace: true });
        return;
      }

      const userDroit = await getDroit();
      await verifUtilisateur(userDroit);
    };

    initApp();
  }, []);

  const getDroit = async () => {
    if (!localStorage.email) {
      navigate('/authentification', { replace: true });
      return '';
    }

    const q = query(
      collection(db, 'autorisations'),
      where('utilisateur', '==', localStorage.email)
    );

    const snapshot = await getDocs(q);
    let foundDroit = '';

    snapshot.forEach(doc => {
      foundDroit = doc.data().autorisation;
      setDroit(foundDroit);
    });

    return foundDroit;
  };

  const verifUtilisateur = async (currentDroit) => {
    const q = query(
      collection(db, 'utilisateurs'),
      where('UUID', '==', localStorage.UUID)
    );

    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      navigate('/authentification', { replace: true });
      return;
    }

    if (!['National', 'Secteur', 'Agence'].includes(currentDroit)) {
      dispatch(aucunDroit());
      navigate('/authentification', { replace: true });
      return;
    }

    if (localStorage.getItem('validationStatus') !== 'true') {
      navigate('/authentification', { replace: true });
      return;
    }

    dispatch(isAuthentified(true));
    navigate('/menu-rapport', { replace: true });
  };

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/authentification" element={<Authentification />} />
        <Route path="/validation" element={<Validation />} />
        <Route path="/menu-rapport" element={<MenuRapport />} />
        <Route path="/rapport" element={<AffichageRapport />} />
      </Routes>
    </>
  );
};

export default App;
